import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';

const useStyles = makeStyles(theme => ({
  fileUploaderCard: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    background: ({ disabled }) => (disabled ? theme.palette.facet.backgroundGray : theme.palette.facet.accentBlue20),
    padding: theme.spacing(3),
    maxWidth: theme.dimensions.md,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: theme.radius.md,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: ({ disabled }) => (disabled ? theme.palette.facet.mediumGray : theme.palette.facet.accentBlue15),
  },
  media: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const BlueCard = ({
  media,
  label,
  loading,
  children,
  disabled,
  LoaderProps,
  onClick,
}) => {
  const classes = useStyles({ disabled });

  return (
    <button className={classes.fileUploaderCard} onClick={onClick} type="button">
      <div className={classes.media}>{loading ? <CircularProgress {...LoaderProps} /> : media}</div>
      <Typography weight="bold" variant="h6" color={disabled ? 'darkGray' : 'primary'}>{label}</Typography>
      {children}
    </button>
  );
};

BlueCard.defaultProps = {
  children: undefined,
  loading: false,
  LoaderProps: {},
  onClick: () => {},
};

BlueCard.propTypes = {
  media: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
  LoaderProps: PropTypes.object,
};

export default BlueCard;
